import { render, staticRenderFns } from "./VisitDetailsHistory.vue?vue&type=template&id=45566ce8&scoped=true"
import script from "./VisitDetailsHistory.vue?vue&type=script&lang=js"
export * from "./VisitDetailsHistory.vue?vue&type=script&lang=js"
import style0 from "./VisitDetailsHistory.vue?vue&type=style&index=0&id=45566ce8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45566ce8",
  null
  
)

export default component.exports